import Constants from '../utils/Constants';
import ServiceBase from './ServiceBase';
import ContainerModel from '../model/ContainerModel';

const GALLERY_URL = 'gallery/';

export default class InventoryGalleryService extends ServiceBase {

  /**
   * Returns the gallery of images
   */
  getGallery = () => {
    let url = this.getServiceUrl(GALLERY_URL);

    let packet = this.buildRequestPacket(Constants.Http.Method.GET);
    
    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        return json;
    });
  }

  /**
   * Gets a individual image form the API
   * @param {*} imageId 
   */
  getImage = (imageId) => {
    let url = this.getServiceUrl(GALLERY_URL + "?" + Constants.Http.Param.Id + "=" + imageId);

    let packet = this.buildRequestPacket(Constants.Http.Method.GET);
    
    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        return json;
    });
  }

  /**
   * Addes a new image to the gallery
   * @param {*} inventoryGallery 
   * @returns 
   */
  addNewImage = (inventoryGallery) => {
    let url = this.getServiceUrl(GALLERY_URL);

    let packet = this.buildRequestPacket(Constants.Http.Method.POST, inventoryGallery);
    
    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        return json;
    });
  }

  /**
   * Delete an image from the gallery
   * @param {*} imageId 
   */
  deleteImage = (imageId) => {
    let url = this.getServiceUrl(GALLERY_URL + "?" + Constants.Http.Param.Id + "=" + imageId);

    let packet = this.buildRequestPacket(Constants.Http.Method.DELETE);
    
    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        return json;
    });
  }

  /**
   * Update a image details.
   * @param {*} image 
   */
  updateImage = (image) => {
    let url = this.getServiceUrl(GALLERY_URL);

    let packet = this.buildRequestPacket(Constants.Http.Method.PUT, image);
    
    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
      return json;
    });
  }
}